import * as React from 'react';
import { ToastListContext, ToastListOptions } from '../utils/ToastListContext';

export const useToastNotifications = () =>
  React.useContext<ToastListOptions>(ToastListContext);
